import { createContext } from "react";
import api from "./api";
import { IApi } from "./contracts";

const ApiContext = createContext<IApi>(api);
export default ApiContext;
